import { Logo, OpenTestBanner, OUTREACH_OPTIONS } from '../lib/ui'

export function Landing() {
  return (
    <main className="landing-shell">
      <header className="landing-nav">
        <Logo />
        <nav>
          <a href="#/how-it-works">How it works</a>
          <a className="nav-signin" href="#/signin">
            Sign in
          </a>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-copy">
          <OpenTestBanner />
          <h1>Meet. Flirt. Follow. Monetize.</h1>
          <p>
            Real profiles, real chemistry, and room to grow your audience — without spam, paywalls on mutual interest, or
            hidden rules.
            <br />
            Link your socials, set your vibe, and connect on your terms.
          </p>
          <blockquote className="product-promise">
            No one is merchandise. Interest has to mean something.
          </blockquote>
          <div className="hero-actions">
            <a className="button primary" href="#/signup">
              Get started <span>→</span>
            </a>
            <a className="button secondary" href="/download">
              Android app
            </a>
          </div>
          <div className="trust-note">
            <span>✓</span> Same rules and pricing for every gender · 18+ only
          </div>
        </div>

        <div className="role-visual" aria-label="Intentional connection diagram">
          <div className="match-orbit orbit-one" />
          <div className="match-orbit orbit-two" />
          <div className="match-center">✓</div>
          {OUTREACH_OPTIONS.map((opt) => (
            <div
              key={opt.value}
              className={`role-float role-${opt.value === 'be_approached' ? 'be_approached' : opt.value}`}
            >
              <span>{opt.value === 'initiate' ? '→' : opt.value === 'be_approached' ? '←' : '↔'}</span>
              <strong>{opt.value === 'initiate' ? 'Initiate' : opt.value === 'be_approached' ? 'Be approached' : 'Either'}</strong>
              <small>Your choice</small>
            </div>
          ))}
        </div>
      </section>

      <section className="how-section how-section--trio" id="how">
        <article className="how-card">
          <span className="step-number">01</span>
          <h2>Build your profile</h2>
          <p>Photos, vibe tags, verified social links, and what you're here for — meet, flirt, subscribe, or monetize.</p>
        </article>
        <article className="how-card">
          <span className="step-number">02</span>
          <h2>Express interest intentionally</h2>
          <p>Daily limits and strong filters keep inboxes manageable. Unmatched introductions go to Requests.</p>
        </article>
        <article className="how-card">
          <span className="step-number">03</span>
          <h2>Mutual interest unlocks messaging</h2>
          <p>Connected members message free. Creators can monetize with custom photo requests and priority discovery.</p>
        </article>
      </section>

      <footer className="landing-footer">
        <nav>
          <a href="/free-messaging-dating-app">Free messaging</a>
          <a href="/safety-standards">Safety &amp; rules</a>
          <a href="/download">Android app</a>
          <a href="#/legal/privacy">Privacy</a>
          <a href="#/legal/terms">Terms</a>
          <a href="mailto:support@pairvelle.com">Support</a>
          <a href="#/how-it-works">How It Works</a>
        </nav>
        <small>
          © {new Date().getFullYear()} PairVelle · Operated by PairVelle · Built by Manticore Technologies · 18+ only
        </small>
      </footer>
    </main>
  )
}

export function HowItWorks() {
  return (
    <main className="landing-shell">
      <header className="landing-nav">
        <Logo />
        <nav>
          <a href="#/signin">Sign in</a>
          <a className="button primary" href="#/signup">
            Create account
          </a>
        </nav>
      </header>

      <div className="how-it-works-page">
        <header className="how-it-works-intro">
          <a className="back-link" href="#/">
            ← Back
          </a>
          <span className="eyebrow">How it works</span>
          <h1>How Pairvelle works</h1>
          <p className="page-sub">Intentional interest. Published standards. Same rules for everyone.</p>
          <div className="hero-actions how-it-works-cta how-it-works-cta--intro">
            <a className="button primary" href="#/signup">
              Get started <span>→</span>
            </a>
            <a className="button secondary" href="#/">
              Back home
            </a>
          </div>
        </header>

        <section className="how-section how-section--quad" aria-label="Product steps">
          <article className="how-card">
            <span className="step-number">01</span>
            <h2>Choose how you connect</h2>
            <p>Set outreach preference (initiate, be approached, or either), connection intent, and optional lifestyle tags.</p>
          </article>
          <article className="how-card">
            <span className="step-number">02</span>
            <h2>Discover with limits</h2>
            <p>Daily caps on expressions of interest reduce spam. Recipients filter who can reach them—including verified-only.</p>
          </article>
          <article className="how-card">
            <span className="step-number">03</span>
            <h2>Matches vs Requests</h2>
            <p>Mutual matches message free in Matches. Unmatched introductions land in a separate Requests inbox.</p>
          </article>
          <article className="how-card">
            <span className="step-number">04</span>
            <h2>Visible account standing</h2>
            <p>
              See your status, active limitations, enforcement notices, and appeal history. No hidden rules — if we
              limit your account, you will know what happened and why. No one is exiled in silence.
            </p>
          </article>
        </section>

        <div className="hero-actions how-it-works-cta" style={{ marginTop: 8 }}>
          <a className="button secondary" href="#/legal/community">
            Read full Safety &amp; Rules
          </a>
        </div>
      </div>

      <footer className="landing-footer">
        <nav>
          <a href="#/legal/community">Safety &amp; rules</a>
          <a href="#/legal/privacy">Privacy</a>
          <a href="#/legal/terms">Terms</a>
          <a href="mailto:support@pairvelle.com">Support</a>
          <a href="#/">Home</a>
        </nav>
        <small>
          © {new Date().getFullYear()} PairVelle · Operated by PairVelle · Built by Manticore Technologies · 18+ only
        </small>
      </footer>
    </main>
  )
}
